<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-va-optimization-response-performance-page" v-loading="loading">
    <div class="wy-va-response-performance">
      <div class="wy-va-opitization-main-content">
        <div class="wy-va-response-performance-title">
          {{$t(currentPageInfo.title)}} <wy-page-tooltip />

          <el-button v-if="showTable && showResponseTable" class="export-btn" :disabled="disableExport" round @click="handleExport">
            <div class="export-icon"></div>
            <span class="export-text">Export</span> 
          </el-button>
        </div>
    
        <div class="wy-va-opitization-response-performance-chart-panel-wrapper" v-if="showChartsPanel" >
          <div class="wy-va-opitization-response-performance-chart-panel">
            
            <div class="chart-section-header" @mouseover="handleShowSettingIcon" @mouseleave="handleHideSettingIcon">
              <div class="header">
                <span>Issues</span>  
                <el-tooltip effect="dark" placement="bottom">
                  <div slot="content"><span v-html="issueTooltip"></span></div>
                  <img class="response-performance-info-icon" src="../../assets/icons/icon_response_page_info.svg">
                </el-tooltip>
                <div class="wy-panel-header-setting-popup">
                  <el-dropdown ref="configureDropdown"  placement="bottom-end" trigger="click" v-if="isSetttingIconShow">
                    <el-tooltip content="configure" placement="bottom">
                        <el-button class="setting-icon" plain>
                            <img class="setting-img" src="../../assets/icons/icon_setting.svg" alt="setting icon">
                            <i class="el-icon-arrow-down el-icon--right setting-arrow-down"></i>
                        </el-button> 
                    </el-tooltip>
                    <el-dropdown-menu slot="dropdown" class="wy-panel-header-setting">
                        <div class="gear-panel">
                            <div class="gear-header">
                                Configure
                                <img @click="handleCloseDropdown" class="close-img" src="../../assets/icons/icon_customer_close.svg" alt="close configure dropdown icon">
                            </div>
                            <div class="gear-flex">
                                <div class="gear-top">
                                  <div class="performance-compare-group-by">
                                    <el-select
                                    v-model="selectedDateRange"
                                    collapse-tags
                                    size="mini"
                                    style="margin-left: 5px;"
                                    class="date-range-dropdown"
                                    popper-class="table-filter-dropdown date-range"
                                    :popper-append-to-body="false"
                                    @change="dateRangeChanged">
                                      <el-option
                                        v-for="(item) in dateRangeTypes"
                                        :disabled="item.disabled"
                                        :key="item.type"
                                        :label="item.label"
                                        :value="item.type">
                                      </el-option>
                                    </el-select>
                                  </div>
                                </div>
                            </div>
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              
              <!-- pie charts -->
              <div class="charts-section" v-if="responseChartData&&responseChartData.dateList&&responseChartData.dateList.length>0">
                <div class="optimization-flex-container" >
                  <div class="optimization-details">
                    <table ref="pies" class="optimization-details-table" border="0" cellspacing="0" cellpadding="0">
                      <tr>
                        <td>
                          <wy-va-optimization-response-pie-chart :title="performanceMetricData.handoffRate[0].label" :parent="module" traceKey="piehandoffRate" :traceList="performanceMetricData.handoffRate" :targetKey="'handoffRate'" />
                        </td>
                        <td>
                          <wy-va-optimization-response-pie-chart :title="performanceMetricData.negativeFeedbackRate[0].label" :parent="module" traceKey="pienegativeFeedbackRate" :traceList="performanceMetricData.negativeFeedbackRate" :targetKey="'negativeFeedbackRate'" />
                        </td>
                        <td>
                          <wy-va-optimization-response-pie-chart :title="performanceMetricData.botRepetitionRate[0].label" :parent="module" traceKey="piebotRepetitionRate" :traceList="performanceMetricData.botRepetitionRate" :targetKey="'botRepetitionRate'" />
                        </td>
                        
                      </tr>
                    </table>
                  </div>
                  <!-- line charts -->
                  <div  class="chart optimizationTrendChart">
                    <wy-va-optimization-response-line-chart v-if="haslineChartData" ref="responseChart" :data="responseChartData" :type="selectedDateRange" />
                    
                  </div>
                  
                </div>
                <div class="optimization-details"></div>
                <div class="chart optimizationTrendChart" style="float: right;">
                  <div class="chart-legend">
                    <div class="legend-flex" v-for="(item, index) in legendsData" :key="index" @click="handleClickLegend(item)">
                      <div class="legend-marker" :class="{'disabled': !item.enable}" :style="{'background-color': item.color}"></div>
                      <div class="legend-name" :class="{'disabled': !item.enable}">{{item.legend}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="no-result-found">
                <div class="no-data"></div>
                <div class="no-data-title">{{$t('noResultFound.title')}}</div>
                <div class="no-data-content">
                  <div class="content-text">
                    {{$t('noResultFound.message')}}
                  </div>
                </div>
              </div>
              

            </div>
            
          
        </div>
        
        <div v-show="showTable && showResponseTable" :class="{'wy-va-optimization-response-performance-table-panel':showChartsPanel, 'wy-va-optimization-response-performance-table-panel full-size':!showChartsPanel}">
          <!-- <div class="table-header"><span style="padding-left:20px">Response Performance</span></div> -->
          <wy-va-optimization-response-performance-header ref="header" :controller="module" />
          <wy-table-list v-loading="loadTables" :class="{'without-charts-table-style': !showChartsPanel}" ref="table" :controller="module" :enableSelection="true" :defaultSort="{name: 'totalResponses', type: 1}" searchFieldName="response" />
        </div>
      </div>

    </div>
  </div>
  
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import WyChartModule from '../../library/wy-chart-module.js';
import wyVaOptimizationPieChart from '../optimization/wy-va-optimization-response-pie-chart';
import wyVaOptimizationLineChart from '../optimization/wy-va-optimization-response-line-chart';
import WyVaResponsePerformanceHeader from './wy-va-optimization-response-performance-header'
import WyTableList from '../widgets/wy-table-list';
import WyPageTooltip from '../widgets/wy-page-tooltip.vue';
import WyUtils from '../../library/wy-utils';

export default Vue.extend({
  name: 'wy-va-optimization-response-performance-page',
  components: {
    'wy-va-optimization-response-pie-chart': wyVaOptimizationPieChart,
    'wy-va-optimization-response-line-chart': wyVaOptimizationLineChart,
    'wy-va-optimization-response-performance-header': WyVaResponsePerformanceHeader,
    'wy-table-list': WyTableList,
    'wy-page-tooltip': WyPageTooltip
  },

  data() {
    return {
      module: this,
      loading: false,
      wyChart: null,
      isSetttingIconShow: false,
      legendsData: [],
      loadTables: false,
      disableExport: false,
      showChartsPanel: null,
      showResponseTable: null,

      selectedDateRange: null,
      issueTooltip: 'Handoffs, negative feedback and bot repetition are common issues and will determine the priority of addressing the responses in the table below.',
      initDate: null,

      showTable: false,
      performanceMetricData: null,
      responseChartData: null,
      localResponseChartData: {},
      
      columns: [
        {label: "", type:"star", name: "index", customCell: 'wy-va-optimization-response-name-cell', selected: true, sortable: false, mandatory: true, group: ' ', minWidth: 20, align:"center", fixed: true},
        {label: "Name", name: "responseName", mandatory: true, selected: false, sortable: true, sortBy: "responseName", group: '', align:"right", minWidth: 350, fixed: true, mainColumn: true, copyable: false, isEditTopicName: false, extendableField: true},
        
        {label: "Total", name: "priority", selected: true, sortable: true, group: 'Priority', minWidth: 100, align:"right"},

        {label: "Total", name: "totalVolume", selected: true, sortable: true, group: 'Times Presented', minWidth: 100, align:"right"},
        {label: "% of total", name: "timesPresented", selected: false, sortable: true, group: 'Times Presented', sortBy: 'timesPresented', minWidth: 170, suffix: "%"},
        
        {label: "Total", name: "totalHandedOff", selected: true, sortable: true, group: 'Handed off', minWidth: 100, align:"right"},
        {label: "% of total", name: "handedOff", selected: false, sortable: true, group: 'Handed off', sortBy: 'handedOff', minWidth: 170, suffix: "%"},

        {label: "Total", name: "totalBotRepetitions", selected: true, sortable: true, group: 'Bot Repetitions', minWidth: 100, align:"right"},
        {label: "% of total", name: "botRepetitions", selected: false, sortable: true, group: 'Bot Repetitions', sortBy: 'botRepetitions', minWidth: 170, suffix: "%"},

        {label: "Total", name: "totalPositiveFeedback", selected: true, sortable: true, group: 'Positive feedback', minWidth: 100, align:"right"},
        {label: "% of total", name: "positiveFeedback", selected: false, sortable: true, group: 'Positive feedback', sortBy: 'positiveFeedback', minWidth: 170, suffix: "%"},

        {label: "Total", name: "totalNegativeFeedback", selected: true, sortable: true, group: 'Negative feedback', minWidth: 100, align:"right"},
        {label: "% of total", name: "negativeFeedback", selected: false, sortable: true, group: 'Negative feedback', sortBy: 'negativeFeedback', minWidth: 170, suffix: "%"},

        {label: "Total", name: "totalNegativeSentiment", selected: true, sortable: true, group: 'Negative sentiment', minWidth: 100, align:"right"},
        {label: "% of total", name: "negativeSentiment", selected: false, sortable: true, group: 'Negative sentiment', sortBy: 'negativeSentiment', minWidth: 170, suffix: "%"},

        {label: "Total", name: "language", customClass:"language", selected: true, sortable: false, sortBy: "language", group: 'Language', minWidth: 100, align:"right"},
        {label: "Total", name: "endResponse", customClass:"end-response", selected: true, sortable: true, sortBy: "endResponse", group: 'End response', minWidth: 100, align:"right"},

        
        {label: "ID", name: "responseId", customClass:"response-id", selected: true, sortable: true, sortBy: "responseId", group: 'Response IDs', minWidth: 580, align:"right"}
      ],
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'config', 'tableModel', 'currentPageInfo', 'companyConfig', 'authUser', 'isLoggedIn']),

    haslineChartData() {
      return this.responseChartData && this.responseChartData.dateList.length > 0;
    },

    dateRangeTypes() {
      return this.wyChart.getDateRangeTypes();
    },
  },

  watch: {
    'loading': function(val) {
      setTimeout(()=>{
        val ? this.showTable = false : this.showTable = true
      }, 300)
    }
  },

  methods: {
    ...mapMutations(['updateDataModelColumns']),
    ...mapActions(["addResponse", "removeResponse", 'fetchOptimizationResponseChartData', 'fetchOptimizationResponsePerformanceSummary']),

    async refreshTable() {
      this.$refs.table.refreshTable();
    },

    async handleExport() {
  
      const selectedColumns = this.columns
      const selectedRows = this.tableModel.results;
      let exportResult = []
      let exportRow = {};
      let value = "N/A"

      delete selectedColumns[0] // delete the index column

      selectedRows.map(row => {
        exportRow['Starred'] = row.savedResponse ? 'Yes' : 'No'; // Add the new column and set its value

        selectedColumns.map(column => {
          const columnName = `${column.group} ${column.label}`;
          const columnValue = row[column.name];

          if (columnName.includes("%")) {
            value = `${Number(columnValue).toLocaleString()}%`
          } else if (typeof columnName == "number") {
            value = Number(columnValue).toLocaleString()
          } else { // string type
            value = columnValue
          }

          if (columnValue == null) {
            return exportRow[columnName] = "N/A";
          }
          else {
            this.dataModel.columns.forEach(el => {
              if(el.name == column.name && el.selected == true){
                if(typeof value == 'string'){
                  exportRow[columnName] = value.replace( /(<([^>]+)>)/ig, '');
                  if(exportRow[columnName].includes(',')){
                    exportRow[columnName] = '"' + exportRow[columnName] +'"';
                  }
                }
                else{
                  exportRow[columnName] = value;
                }      
              }
            })
          } 
        });

        exportResult.push(exportRow);
        exportRow = {};
      });

      function convertToCSV(arr) {
        if (!arr.length) return '' // Guard against exporting no saved transcripts
        const array = [Object.keys(arr[0])].concat(arr)
        array[0].forEach((el, index) => {
          array[0][index] = el.trim()
        }); 
        return array.map(item => {
          return Object.values(item).toString()
        }).join('\n')
      }

      const csv = convertToCSV(exportResult);
      const csvContent = await csv.toString();

      let exportedFilenmae = `${this.authUser.company.name.replace(/ /g, "_")}_Response _Performance_Table_${this.dataModel.dateStart}_to_${this.dataModel.dateEnd}.csv`;
      let blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      let downloadLink = document.createElement("a");
      if (downloadLink.download !== undefined) {
        let url = URL.createObjectURL(blob);
        downloadLink.setAttribute("href", url);
        downloadLink.setAttribute("download", exportedFilenmae);
        downloadLink.style.visibility = 'hidden';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        const eventInfo = {
          number_of_exported_responses: exportResult.length,
          saved_filter_on: this.$refs.header.savedResponsesEnabled
        }
        this.$router.logAmplitudeEvent({eventName: "export_responses", eventInfo});
      }
    },

    handleTableColumnOpenAmplitude() {
      this.$router.logAmplitudeEvent({eventName: "response_column_selector_opened"});
    },

    handleTableColumnApplyAmplitude(updateColumnsInfo) {
      const eventInfo = {
        changes_made: updateColumnsInfo.changes_made,
        all_selected: updateColumnsInfo.all_selected,
        columns_added: updateColumnsInfo.columns_added,
        columns_removed: updateColumnsInfo.columns_removed,
        columns_selected: updateColumnsInfo.columns_selected
      }
      this.$router.logAmplitudeEvent({eventName: "response_column_selector_applied", eventInfo});
    },

    handleClickLegend(legendItem) {
      let count = 0;
      this.legendsData.forEach(legend => {
        if(legend.enable) {
          count++
        }
      })
      if(count > 1) {
        if(legendItem.hasData) {
          legendItem.enable = !legendItem.enable;
        }
        else {
          if(legendItem.hasData) {
            if(!legendItem.enable) {
              legendItem.enable = !legendItem.enable;
            }
          }
          else {
            legendItem.enable = false
          }
        }
      }
      else {
        if(!legendItem.enable) {
          legendItem.enable = !legendItem.enable;
        }
      }
      if(legendItem.enable) {
        if(this.localResponseChartData[legendItem.key + 'List']) {
          this.localResponseChartData[legendItem.key + 'List'] = this.responseChartData[legendItem.key + 'List']
        }
      }
      else {
        if(this.localResponseChartData[legendItem.key + 'List']) {
          this.localResponseChartData[legendItem.key + 'List'] = []
        }
      }
      
      setTimeout(() => {
        if(this.$refs.responseChart) {
          this.$refs.responseChart.buildChart(this.localResponseChartData, true);
        }
      }, 50);
    },

    dateRangeChanged(selectedDateRange) {
      if(this.responseChartData.rawData.dailyMetrics.length > 0) {
        let dateStart = moment(this.responseChartData.rawData.dailyMetrics[0].date);
        let dateEnd = moment(this.responseChartData.rawData.dailyMetrics[this.responseChartData.rawData.dailyMetrics.length-1].date);
        this.wyChart.init(selectedDateRange, dateStart, dateEnd, null, (this.companyConfig.default || {}).selectedViewBy || "month");
        this.selectedDateRange = this.wyChart.selectedDateRange;
        this.formatData(this.selectedDateRange);
      }      

      setTimeout(() => {
        if(this.$refs.responseChart) {
          this.localResponseChartData = JSON.parse(JSON.stringify(this.responseChartData))
          this.$refs.responseChart.buildChart(this.localResponseChartData, false);
        }
      }, 50);
      this.handleCloseDropdown()
    },

    formatData(dateRange) {
      let data = JSON.parse(JSON.stringify(this.responseChartData));
      let chartData = this.averageGroupBy(dateRange, data.rawData.dailyMetrics, ['botRepetitionRate', 'handoffRate', 'negativeFeedbackRate']);

      if(chartData && chartData.length > 0) {
        this.responseChartData.dateList = [];
        this.responseChartData.handoffRateList= [];
        this.responseChartData.negativeFeedbackRateList = [];
        this.responseChartData.botRepetitionRateList = [];
        chartData.forEach(dailyMetric => {
          if(chartData.length == 1) {
            switch (dateRange) {
              case 'day':
                dailyMetric.date = moment(dailyMetric.date,'YYYY-MM-D').format("MMM DD YYYY");
                break;
              case 'week':
                dailyMetric.date = moment(dailyMetric.date,'YYYY-MM-D').format("MMM DD YYYY");
                break;
              case 'year':
                dailyMetric.date = moment(dailyMetric.date,'YYYY-MM-D').format("YYYY");
                break;
              default:
                dailyMetric.date = moment(dailyMetric.date,'YYYY-MM-D').format("MMM YYYY");
            }
          }
          else {
            switch (dateRange) {
              case 'day':
                // sectionData.lineChartData.xAxisData[charDataIndex] = dailyMetric.date;
                break;
              case 'week':
                dailyMetric.date = moment(dailyMetric.date,'YYYY-MM-D').format("MMM DD YYYY");
                break;
              case 'month':
                dailyMetric.date = moment(dailyMetric.date,'YYYY-MM-D').format("MMM YYYY");
                break;
              case 'year':
                dailyMetric.date = moment(dailyMetric.date,'YYYY-MM-D').format("YYYY");
                break;
              default:
                dailyMetric.date = moment(dailyMetric.date,'YYYY-MM-D').format("MMM YYYY");
            }
          }
          this.responseChartData.dateList.push(dailyMetric.date);
          this.responseChartData.handoffRateList.push(dailyMetric.handoffRate);
          this.responseChartData.negativeFeedbackRateList.push(dailyMetric.negativeFeedbackRate);
          this.responseChartData.botRepetitionRateList.push(dailyMetric.botRepetitionRate);
        })
      }
    },

    averageGroupBy(viewBy, ChartData, fieldNames) {      
      ChartData.forEach(el => {
        this.wyChart.prepareGroupDates(el, el.date);
      })
      
      ChartData = this.wyChart.groupBy(ChartData, (items) => {
        let obj = {date: items[0].date};
        let dateRange = '';
        dateRange = moment(items[0].date,'YYYY-MM-D').format("MMM DD YYYY");
        if(viewBy == 'week') {
          if(items.length > 1) {
            dateRange = dateRange + ' - ' + moment(items[items.length - 1].date,'YYYY-MM-D').format("MMM DD YYYY");
          }
        }
        fieldNames.forEach(fieldName => {
          obj[fieldName] = _.sumBy(items, fieldName)/items.length;
          obj.toolTipsRange = dateRange;
        })
        return obj
      })
      return ChartData
    },

    handleCloseDropdown(){
      if(this.$refs.configureDropdown){
        this.$refs.configureDropdown.hide();
      }
    },

    renderLegends(legendObj) {
      let legendMapping = {
        'Negative feedback rate': 'negativeFeedbackRate',
        'Handoff rate': 'handoffRate',
        'Bot repetition rate': 'botRepetitionRate'
      }
      this.legendsData = [];
      legendObj.legends.forEach((item, index) => {
        let obj = {};
        obj.legend = item;
        obj.enable = false;
        obj.key = legendMapping[item];
        obj.color = '#c9d3da';
        obj.hasData = false;
        this.responseChartData[obj.key + "List"].forEach(val => {
          if(val != -1) {
            obj.hasData = true
            obj.enable = true;
            obj.color = legendObj.colors[index];
          }
        })
        this.legendsData.push(obj);
      });
    },

    async fetchResponsePerformanceChartData() {
      //response charts data
      let optimizationResponseRawChartData = await this.fetchOptimizationResponseChartData();
      this.performanceMetricData = optimizationResponseRawChartData.totalPerformanceMetricData;//pies
      this.responseChartData = optimizationResponseRawChartData.trendPerformanceMetricData;//lines
      this.localResponseChartData = JSON.parse(JSON.stringify(this.responseChartData));
      
      setTimeout(() => {
        this.dateRangeChanged();
      }, 300);

      return new Promise((resolve) => { resolve(true)})
    },

    async fetchResponsePerformanceSummary(options) {

      return this.fetchOptimizationResponsePerformanceSummary(options);
    },

    async handleFilterChange() {
      if((!this.loading && this.dataModel.dateEnd) ||this.dataModel.dateEnd) {
        this.loading = true;
        if (this.$refs.header) {
          this.$refs.header.savedResponsesEnabled = false;
          this.$refs.header.keyword = '';
        }
        
        if(this.showResponseTable && this.showChartsPanel){
          await this.fetchResponsePerformanceChartData();
          await this.fetchResponsePerformanceSummary();
        }
        else if(this.showResponseTable && !this.showChartsPanel){
          await this.fetchResponsePerformanceSummary();
        }
        else if(this.showChartsPanel && !this.showResponseTable){
          await this.fetchResponsePerformanceChartData();     
        }
        else if (!this.showResponseTable && !this.showChartsPanel){
          await null;
        }
        else {
          await this.fetchResponsePerformanceSummary();
        }


        if(this.$refs.table) {
          this.$refs.table.refreshTable();
        }        
        else {
          this.loading = false;
        }
      }

      if(this.tableModel.results.length == 0){
        this.disableExport = true;
      } else {
        this.disableExport = false;
      }
    },

    handleShowSettingIcon(){
      if(this.responseChartData && this.responseChartData.dateList && this.responseChartData.dateList.length > 0) {
        this.isSetttingIconShow = true;
      }
    },

    handleHideSettingIcon(e){
      if(this.responseChartData && this.responseChartData.dateList && this.responseChartData.dateList.length > 0) {
        if(e.toElement && (e.toElement._prevClass == "wy-va-response-performance-title" || e.toElement._prevClass == 'el-main wy-container-main'|| e.toElement._prevClass == 'wy-va-opitization-response-performance-chart-panel')) {
          this.isSetttingIconShow = false;
        }
      }
    },

    async addSavedResponse(response) {
      let result = await this.addResponse({responseId: response.responseId});
      if(result && result.status && result.status == 200) {
        response.savedResponse = true;        
      }
    },

    async removeSavedResponse(response) {
      let result = await this.removeResponse({responseId: response.responseId});
      if(result && result.status && result.status == 200) {

        if(this.$refs.header.savedResponsesEnabled){
          let removeResId = '';
          removeResId = response.responseId;

          for(let i = 0; i < this.tableModel.results.length; i++){
            if(this.tableModel.results[i].responseId == removeResId){
              this.tableModel.results.splice(i, 1)
            }
          }
        }

        response.savedResponse = false;
      }

      // if the last saved response is removed, hide export button
      if(this.tableModel.results.length == 0){
        this.disableExport = true;
      }
    }
  },

  async created() {   
    this.initDate = new Date() 
    Vue.component("wy-va-optimization-response-name-cell", () => import('./wy-va-optimization-response-name-cell.vue'));
    
    this.wyChart = new WyChartModule();

    // listen events from other components
    this.$root.registerPageEvent(this.$route.name, (event) => {
      if(this[event.name]) this[event.name]();
    })

    this.updateDataModelColumns({columns: this.columns});

  },

  beforeDestroy() {
    this.dataModel.keyword = '';
  },

  async mounted(){
    this.$root.$on(`fire-response-legends-events`, (legendObj) => {
      this.renderLegends(legendObj)
    });

    if(this.config && this.companyConfig){
      let keyArrOne = []
      this.config.appPanels.forEach(el => {
        el.key == "wy-va-optimization-response-performance-chart-panel" && el.enabled == false ? this.showChartsPanel = false: el.key == "wy-va-optimization-response-performance-chart-panel" && el.enabled == true ? this.showChartsPanel = true:{}
        
        el.key == "wy-va-optimization-response-performance-table-panel" && el.enabled == true ? this.showResponseTable = true: el.key == "wy-va-optimization-response-performance-table-panel" && el.enabled == false ? this.showResponseTable = false:{}
        keyArrOne.push(el.key)
      })
      !keyArrOne.includes('wy-va-optimization-response-performance-chart-panel')? this.showChartsPanel = false:{};
      !keyArrOne.includes('wy-va-optimization-response-performance-table-panel')? this.showResponseTable = true:{};

      let keyArrTwo = []
      this.companyConfig.appPanels.forEach(el => {
        el.key == "wy-va-optimization-response-performance-chart-panel" && el.enabled == true? this.showChartsPanel = true: el.key == "wy-va-optimization-response-performance-chart-panel" && el.enabled == false? this.showChartsPanel = false: {};
        el.key == "wy-va-optimization-response-performance-table-panel" && el.enabled == true ? this.showResponseTable = true: el.key == "wy-va-optimization-response-performance-table-panel" && el.enabled == false ? this.showResponseTable = false:{}
        
        keyArrTwo.push(el.key)
      })
      !keyArrTwo.includes('wy-va-optimization-response-performance-chart-panel')? this.showChartsPanel = false:{};
      !keyArrTwo.includes('wy-va-optimization-response-performance-table-panel')? this.showResponseTable = true:{};


      await this.handleFilterChange();
    }
  },

  destroyed() {
    if(this.isLoggedIn) {
      this.$store.dispatch('amplitudeLogWithFilters', {name: 'optimization_resposne_performance_time_spent', data: {time_spent: WyUtils.getTimeDiff(this.initDate)}});
    }
  }
});
</script>

<style lang="scss">
  .response-date-dropdown {
    width: 240px;
    height: 125px;
    padding: 0px;
    border-radius: 8px;

    .el-select.date-range-dropdown.el-input--mini .el-input__inner {
      border: none !important;
    }
    img.close-img {
      width: 15px ;
      float: right !important;
      margin-left: auto;
    }
    .el-select .el-input .el-select__caret {
      color: #828E9A;
      font-size: 12px;
    }
    .gear-header {
      padding: 19px;
      height: fit-content !important;
      border-bottom: 1px #CAD2DA solid !important;
    }
  }
  .response-page-group-by{
    padding-top: 18px;
    padding-left: 19px;
    .el-select.date-range-dropdown.el-select--mini{
      width: 7.86vw !important;
      min-width: 128px;
      border: 1px #DCDFE6 solid;
      border-radius: 5px;
      position: relative;
      right: 0.24vw;
    }
    .el-select.date-range-dropdown.el-select--mini:active{
      border: 1px solid #1C4DB2;
    }
    input.el-input__inner {
      border-width: 0px 0px 1px 0px !important;
      border-radius: 5px;
      padding-left: 5px;
    }
    .el-input__inner {
      border: 1px solid transparent !important;
      &:hover{
        background: #F4F6F8;
      }
    }
  }
  .wy-responsePerformance-page{
    // .wy-container .wy-container-body .wy-container-main {
    //   overflow: hidden !important;
    // }
  }
  .wy-va-optimization-response-performance-table-panel.full-size {
    // .wy-table-list .wy-table-wrapper {
    //   height: calc( 100vh - 255px);
    // }
    // .without-charts-table-style tbody.wy-body {
    //   height: calc( 100vh - 358px);
    // }
    // .without-charts-table-style .wy-table-fixed tbody.wy-body {
    //   height: calc( 100vh - 378px) !important;
    // }
    .without-charts-table-style {
      border-bottom: 0px;
    }
    padding-bottom: 0px !important;
  }
    
  .wy-va-optimization-response-performance-page {
    // font-weight: 500;
    font-size: 14px;
    padding-top: 0px;
    .table-header {
      border: 1px solid #CAD2DA;
      height: 60px;
      background-color: #FFF;
      color: var(--site-font-secondary-color);
      font-weight: 500;
      display: flex;
      font-size: 20px;
      width: 100%;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      align-items: center;
    }
    .wy-page-nodata-with-available-date-range {
      // margin-top: -12%;
      // margin-bottom: 11%;
      margin-top: 0px;
      margin-bottom: 0px;
      height: 80%;
    }
    .no-result-found{
      height: calc(100vh - 935px) !important;
      min-height: 232px;
      max-height: 232px;
      margin-bottom: 25px;

      .no-data {
        height: 50% !important;
        min-height: 95px !important;
        max-height: 150px !important;
        margin-top: 2.5em !important;
        margin-bottom: 1% !important;
        background-position-x: 50% !important;
        background-size: contain !important;
      }
    }
    span.by-month-text {
      float: right;
      font-size: 14px;
      color: var(--site-font-tertiary-color);
      font-family: 'Helvetica Neue';
      position: relative;
      top: 62px;
      right: 44px;
    }

    .legend-marker {
      border-radius: 50%;
      width: 10px;
      height: 10px;
    }
    .chart-legend{
      display: flex;
      width: 89%;
      height: 30px;
      overflow-y: hidden;
      position: relative;
      left: 38px;
      top: -20px;
      // margin-bottom: 25px;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
    }
    .legend-flex {
      display: flex;
      height: 25px;
      -webkit-box-align: center;
      align-items: center;
      margin-right: 10px;
      cursor: pointer;
    }
    .legend-marker {
      margin: 5px;
      cursor: pointer;
    }
    .legend-marker.disabled {
      opacity: 0.5;
    }
    .legend-name {
      font-size: 14.22px;
      color: var(--site-font-tertiary-color);
      font-weight:400;
      line-height: 1;
      cursor: pointer;
    }
    .legend-name.disabled {
      opacity: 0.5;
    }
    .wy-va-optimization-response-pie-chart .wy-va-optimization-response-pie-chart-title .el-icon-info{
      display: none;
    }
    .wy-table-fixed tbody.wy-body {
      height: calc(100vh - 375px) !important;
      min-height: 366px;
    }
    tbody.wy-body {
      height: calc(100vh - 354px) !important;
      min-height: 390px;
    }
    .wy-table-list .wy-table-fixed {
      // border-top: 1px solid #eee;
      border-left: none !important;
      border-left: 1px solid #eee;
      border-top-left-radius: 15px;

      .wy-sub-header{
        th.sortable::after {  // this reserves space for the up-arrow/down-arrow icon (not shown yet)
          content: "";
          display: inline-block;
          height: 15px;
          background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
          width: 15px;
          position: relative;
          top: 4px;
          left: 7px;
          background-repeat: no-repeat;
        }
      }
      th.sortable.sorted.ascending::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
      }
      th.sortable.sorted.descending::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
      }
      th.sortable.sorted.ascending:hover::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
      }
      th.sortable.sorted.descending:hover::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
      }
      th.sortable:hover {
        background-color: #E1E6EC;
        cursor: pointer;
        color: #214586;
        .sort-caret.ascending {
          background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
        }
        .sort-caret.descending {
          background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
        }
      }
      th.sortable:not(.sorted):hover::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
      }
      th:not(.sortable) {
        span {
          padding-left: 0;
        }
      }
    }
    .wy-table-list{
      .el-button:focus, .el-button:hover {
        border-color: transparent !important;
        background-color: transparent !important;
      }
    }

    .wy-table-list .wy-table-fixed tbody td:nth-last-child(1), .wy-table-list tbody tr td {
      // font-weight: 500 !important;
      color: var(--site-font-tertiary-color) !important;
      // border-bottom: 1px solid #CAD2DA;
      font-size: 14.22px !important;
      div {
        align-items: center;
      }
    }
    .wy-table-list .wy-table-fixed tbody td:nth-last-child(1) {
      padding-left: 10px;
      padding-right: 0px;
      font-weight: 500;
      font-size: 14.22px;
      color: #0C2837 !important;
      text-align: left !important;
      // text-decoration: underline;
    }
    .wy-table-list .wy-table-fixed thead th:nth-last-child(1) {
      padding-left: 20px;
      text-align: left !important;
    }
    .wy-table-list .wy-table-fixed thead th:nth-last-child(1), .total-topic-num{
      color: var(--site-font-secondary-color);
      font-size: 14.5px !important;
      font-weight: 500;
    }
    // .wy-table-list .highlightedRow td {
    //   background: none !important;
    // }
    // .wy-table-list .highlightedRow td.fixed.last-child {
    //   background-color: white !important;
    // }
    .wy-table-list .wy-table-wrapper{
      border: 1px solid #CAD2DA;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      overflow: hidden;
      // border-top: unset;
      min-height: 494px;
      margin-bottom: 20px;
      height: calc( 100vh - 250px);
      border-radius: 8px;
      th.wy-table-tail {
        display: none;
      }
    }
    .wy-table-list tbody tr td.last-child{
      border-right: 1px solid transparent!important;
      text-align: center !important;
    }

    .wy-table-list, .wy-table-fixed tbody tr td {
      background-color: white !important;
      border-bottom: 1px solid #EEE;
    }
    .wy-table-fixed tbody tr td.fixed:first-child {
      width: 39px !important;
      min-width: unset !important;
      max-width: unset !important;
    }
    .wy-header th, .wy-sub-header th {
      background-color: #F5F8FA !important;
      padding: 15px 10px 15px 10px;
      // border-right: 1px solid transparent !important;
    }
    th.lastChild.fixed.index {
      border-bottom: 1px solid #CAD2DA !important;
    }
    .wy-sub-header th.fixed.index {
      border-right: 1px solid #CAD2DA !important;
    }
    .wy-header th.fixed:first-child {
      border-right: 1px solid #CAD2DA !important;
    }
    .show-fixed-table-shadow{
      box-shadow: 5px -2px 10px -10px grey;
      border-right: none !important;
    }
    .regular-fixed-thead-style{
      background-color: white !important;
      border-bottom: 1px solid transparent;
      // border-right: 1px solid #CAD2DA !important;
    }
    .wy-table-list thead .wy-header th, .wy-table-list thead .wy-sub-header th.lastChild, .wy-table-list thead .wy-header th {
      // border-right: 1px solid #CAD2DA;
    }
    .wy-table-list .wy-table-main thead .wy-sub-header th.lastChild {
      text-align: center !important;
    }
    .wy-table-list thead tr.wy-sub-header > th:first-child {
      min-width: 350px !important;
      color: var(--site-font-secondary-color) !important;
    }
    .wy-table-list thead{
      tr.wy-header .wy-table-tail{
        //border-bottom: none !important;
      }
      tr.wy-header, tr.wy-sub-header {
      > th:first-child {
        min-width: 350px !important;
        //border-bottom: 1px solid #CAD2DA;
        border-right: 1px solid transparent;
        }
      }
      .wy-sub-header{
        th.sortable::after {  // this reserves space for the up-arrow/down-arrow icon (not shown yet)
          content: "";
          display: inline-block;
          height: 15px;
          background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
          width: 15px;
          position: relative;
          top: 4px;
          left: 7px;
          background-repeat: no-repeat;
        }
      }
      th.sortable.sorted.ascending::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
      }
      th.sortable.sorted.descending::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
      }
      th.sortable.sorted.ascending:hover::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
      }
      th.sortable.sorted.descending:hover::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
      }
      th.sortable:hover {
        background-color: #E1E6EC;
        cursor: pointer;
        color: #214586;
        .sort-caret.ascending {
          background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
        }
        .sort-caret.descending {
          background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
        }
      }
      th.sortable:not(.sorted):hover::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
      }
      th:not(.sortable) {
        span {
          padding-left: 0;
        }
      }
    }
    .wy-table-list .wy-table-main thead .wy-header th, .wy-table-list .wy-table-main thead .wy-sub-header th {
      background-color: #F5F8FA !important;
      //border-bottom: 1px solid #CAD2DA;
      color: var(--site-font-secondary-color);
      font-size: 14.5px;
      font-weight: 500;
    }
    .wy-table-list .wy-table-main thead .wy-header th:nth-last-child(2), .wy-table-list .wy-table-main thead .wy-header th:nth-last-child(3), .wy-header th:nth-last-child(4){
      // border-bottom: none !important;
    }
    .wy-table-list .wy-table-main thead .wy-header th.language, .wy-table-list .wy-table-main thead .wy-header th.end-response, .wy-table-list .wy-table-main thead .wy-header th.response-id {
      border-bottom: none !important;
      // border-right: none !important;
    }
    .wy-table-list .wy-table-tail {
      min-width: 22px !important;
    }
    .wy-table-list .wy-table-main thead th:nth-last-child(2) {
      // border-right: none !important;
    }

    .optimization-flex-container{
      display: inline-flex;
      padding: 0px 10px;
      height: 265px;
      width: 99%;
      // margin-bottom: 10px;
      align-items: center;
    }
    .response-performance-info-icon{
      margin-top: 1px;
      /* font-size: 10px; */
      width: 17px;
      position: relative;
      top: 1px;
      left: 5px;
    }
    .no-data-table-wrapper{
      overflow: hidden !important;
    }
    .wy-table-list .wy-table-main thead tr.wy-sub-header th :first-child {
      padding-left: 10px;
    }
    .wy-table-list td.align-right div {
      padding-right: 5px;
    }
    .wy-table-main tbody {
      overflow: scroll;
      // height: 964px;
      // min-height: 528px;
      // width: 100%;
      width: calc(100% - 1px);
      max-width: 120%;
      border-bottom: unset;
      &::-webkit-scrollbar {
        width: 20px;
        height: 20px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 150px;
        border: 5px solid transparent;
        border-top: 6px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#FFF;
        border-top: 1px solid #CAD2DA;
      }
      &::-webkit-scrollbar:vertical {
        width: 14px;
      }
      &::-webkit-scrollbar-thumb:vertical {
        border-radius: 160px;
        border: 2px solid transparent;
        border-left: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track:vertical {
        border-top: none !important;
        border-left: 1px solid #CAD2DA;
      }
    }
    .wy-table-main {
      width: 100%;
      // border-top: 1px solid #eee;
      max-width: 100%;
    }
    .wy-table-list {
      width: 100%;
      position: relative;
      // right: 27px;
    }
    .wy-va-response-performance {
      .wy-va-optimization-response-performance-table-panel {
        min-width: 834px;
        // padding-bottom: 20px;
      }
      .wy-va-response-performance-small-title {
        padding: 10px 23px 0px 0px;
        color: var(--site-font-secondary-color);
        font-size: 15px;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: 400;
      }
      .annotation-text {
        font-weight: 600;
      }
      .wy-va-response-performance-title {
        color: var(--site-font-secondary-color);
        font-size: 25px;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: 600;
        // margin-bottom: 24px;
        min-width: 800px;
        padding-top: 0px;
        padding: 0px 0px 20px 0px;
        height: 25px;
        line-height: 0.7;
        margin-bottom: 8px;

        .export-btn {
          box-sizing: border-box;
          border-radius: 5px;
          background: var(--site-button-secondary-btn-background-primary-color);
          color: var(--site-button-secondary-btn-text-primary-color) !important;
          border: 1px solid var(--site-button-secondary-btn-hover-border-primary-color);
          padding: 6px 15px 9px 11px !important;
          width: 90px;
          font-size: 16px !important;
          font-weight: 500 !important;
          height: 36px;
          float: right;
        }
        .export-btn:hover {
          border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
          background-color: var(--site-button-secondary-btn-hover-background-primary-color) !important;
          border-radius: 5px;
          color: var(--site-button-secondary-btn-text-primary-color) !important;
        }
        .export-btn:active {
          background-color: var(--site-button-secondary-btn-pressed-background-primary-color) !important;
        }
        .export-btn:focus {
          border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
          border-radius: 5px;
          color: var(--site-button-secondary-btn-text-primary-color) !important;
        }
        .export-icon {
          background: var(--icon_action_export);
          height: 17px;
          width: 13px;
          position: relative;
          top: 2px;
          height: 17px;
          width: 13px;
          display: inline-block;
          background-repeat: no-repeat;
        }
        .export-text {
          position: relative;
          bottom: 1px;
          left: 5px;
        }
      }
      .wy-va-opitization-main-content {
        height: unset;
        margin-right: 0px !important;
        .wy-va-opitization-response-performance-chart-panel-wrapper {
          background-color: #fff;
          overflow: hidden;
          width: calc(100% - 1px);
          height: fit-content;
          margin-bottom: 8px;
          padding-top: 8px;
        }
        .chart-section-header{
          display: none;
          font-size: 18px;
          font-weight: 500;
          // display: flex;
          color: var(--site-font-secondary-color);
          border-bottom: 1px solid #CAD2DA;
          justify-content: space-between;
          padding: 14px 10px 15px 20px;

          .header {
            display: flex;
            width: 100%;
            height: 23px;
            .wy-panel-header-setting-popup {
              display: flex;
              float: right;
              margin-left: auto;
              left: 0px;
              .setting-img {
                top: 3px !important
              }
            }
          }

          .response-setting-icon{
            float: right;
            margin-top: 2px;
            margin-right: 7px;
            i.el-icon-arrow-down.el-icon--right.setting-arrow-down {
              display: none;
            }
          }
          
        }

        .wy-va-opitization-response-performance-chart-panel {
          box-sizing: border-box;
          width: 100%;
          border: 1px solid #CAD2DA;
          border-radius: 5px;
          max-height: 363px;
          min-height: 300px;
          .response-setting-dropdown{
            float: right;
            margin-left: auto;
          }
          .setting-icon{
            border: none !important;
            padding: 0px;
            margin-right: 5px;
            margin-top: 1px;

            .el-icon--right {
              margin-left: 5px;
              display: none;
            }
          }
          .optimizationTrendChart {
            .svg-container {
              .main-svg {
                width: inherit !important;
                background-color: transparent !important;
                .bglayer .bg {
                  fill: transparent !important;
                }
              }
            }
          }

          .js-plotly-plot .plotly, .js-plotly-plot .plotly div {
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
          }
          .xtick text, .ytick text, .legendtext, .annotation-text {
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
          }
        }
      }

      .wy-va-optimization-response-performance-chart-panel {
        margin-bottom: 50px;
        margin: 10px 0px 0px 0px;
        width: unset;
        height: fit-content;
      }

      .optimization-details {
      margin-left: -30px;
      width: 45%;
      min-width: 553px;

        .optimization-details-table {
          width: 100%;
          td {
            text-align: center;
            width: 25%;
          }
        }
        .wy-va-optimization-response-pie-chart-title {
          padding-bottom: 10px;
          height: 12px;
        }
      }
      .chart.optimizationTrendChart {
        width: 55%;
        min-width: 441px;
        margin-bottom: 0px;
      }
      .wy-va-optimization-response-line-chart {
        padding: 0px;
        margin-bottom: 0px;
        margin-top: 0px;

        .user-select-none.svg-container {
          height: 220px !important;
          width: 100% !important;

          .main-svg .infolayer .legend {
            transform: translate(44.96px, 235.75px);
          }
        }
      }
    }
    
    .el-loading-mask {
      opacity: 1;
      height: calc(100vh - 100px) !important;
    }
  }
  // CSS styles related to svg charts generated by Chartist library from the backend
  .ct-area {
    fill-opacity: 0.5;
  }
  .ct-line {
    stroke-width: 1px;
  }
  .ct-series-a .ct-area, .ct-series-a .ct-slice-donut-solid, .ct-series-a .ct-slice-pie {
    fill: #E6E7F8;
  }
  .ct-series-a .ct-bar, .ct-series-a .ct-line, .ct-series-a .ct-point, .ct-series-a .ct-slice-donut {
    stroke: #4D50E8;
  }
  .ct-series-b .ct-area, .ct-series-b .ct-slice-donut-solid, .ct-series-b .ct-slice-pie {
    fill: #E8F1FF;
  }
  .ct-series-b .ct-bar, .ct-series-b .ct-line, .ct-series-b .ct-point, .ct-series-b .ct-slice-donut {
    stroke: #1C4DB2;
  }
  .ct-series-c .ct-area, .ct-series-c .ct-slice-donut-solid, .ct-series-c .ct-slice-pie {
    fill: none;
  }
  .ct-series-c .ct-bar, .ct-series-c .ct-line, .ct-series-c .ct-point, .ct-series-c .ct-slice-donut {
    stroke: black;
    stroke-dasharray: 3px, 3px;
    stroke-width: 0.5px;
  }

  .wy-panel-header-setting {
    .gear-top{
      display: flex !important;
      align-items: center;
      padding: 10px 20px 0px 20px;
      font-weight: 500;
      font-size: 14px;

      .table-filter-dropdown .el-select-dropdown__item {
        height: 29px;
        line-height: 33px;
        font-weight: normal;
        font-size: 14px;
        padding: 0 10px;
        margin: 2px 0px 0px 0px !important;
        &:hover{
          background: #F4F6F8 !important;
        }
        &:active{
          background: #E8F1FF !important;
          color: #1C4DB2;
        }
      }
      .table-filter-dropdown .el-select-dropdown__item.selected {
        border: none;
        background-image: none !important;
      }
    }

    .gear-panel {
      margin-bottom: 0px;
      width: 274px;
      // height: 80px;
    }
    .el-input__inner {
      font-family: "Helvetica Neue", Helvetica !important;
      border-radius: 5px;
      padding: 8px 12px;
      font-size: 14.22px;
      font-family: Helvetica Neue, Helvetica;
      color: var(--site-font-tertiary-color);
      font-weight: normal;
      &:hover{
        background: #F4F6F8;
      }
    }
    .gear-header {
      border-bottom: 1px solid #CAD2DA;
      margin-bottom: 0px;
      padding: 14px 12px 12px 20px !important;
      font-weight: 500;
      font-size: 14.22px;
    }
    
    .add-filter-img{
      position: relative;
      margin-right: 5px;
      user-select: none !important;
      width: 11px;
      cursor: pointer;
      &:hover{
        background: #F4F6F8;
      }
    }
    .close-img{
      width: 10px;
      cursor: pointer;
      user-select: none !important;
      float: right;
      position: relative;
      top: -10px;
      &:hover{
        background: #F4F6F8;
      }
    }
    .gear-row{
      width: 300px;
    }
    .add-fiter.gear-row{
      font-size: 12px !important;
      display: flex;
    }
    .apply-div{
      height: 44px;
      border-top: 0.5px solid #CAD2DA;
      padding-top: 6px;
      .apply-btn ,.reset-btn, .cancel-btn{
        position: relative;
        bottom: -6px;
        right: 27px;
        // right: 174px;
        font-size: 14px;
        color: var(--site-font-chart-color);
        width: 55px;
        height: 30px;
        border-radius: 4px;
        padding: 0px;
        float: right;
        .char {
          margin-left: auto;
          color: #d2d2d2;
        }
        .apply-text{
          position: relative;
          // right: 21px;
          font-weight: normal;
          font-size: 14px;
        }
      }
      .reset-btn {
        float: left;
        left: 8px;
        border: 0px;
        color: #1C4DB2;
      }
      .cancel-btn {
        float: left;
        left: 5px;
        border: 0px;
        color: #1C4DB2;
      }
      .reset-btn:hover {
        border-color: #1C4DB2 !important;
        color: #1C4DB2 !important;
        text-decoration:underline;
      }
      .cancel-btn:hover {
        border-color: #1C4DB2 !important;
        color: #1C4DB2 !important;
        // text-decoration:underline;
      }
      .el-button.is-plain:focus, .el-button.is-plain:hover {
        border-color: var(--site-font-drop-down-secondary-color);
        color: var(--site-font-drop-down-secondary-color)
      }
    }
  }

  @media screen and (max-width: 1509px) {
    .wy-va-response-performance .wy-va-optimization-response-line-chart {
      .main-svg .infolayer .legend {
        transform: translate(44.96px, 220.75px) !important;
      }
    }
  }

  @media screen and (max-width: 1725px) {
    // .wy-va-optimization-response-pie-chart .wy-va-optimization-response-pie-chart-title .el-icon-info.wy-va-optimization-response-pie-chart-chart-pieMessagesNotUnderstood {
    //   top: 2px;
    //   left: 119px;
    // }
  }

.el-table .ascending .sort-caret.ascending {
  border-bottom-color: #0C2837;
}

.el-table .descending .sort-caret.descending {
  border-top-color: #0C2837;
}

</style>